import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useParams, useSearchParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callCheckItemListGet } from "../../actions/check-items"
import TableView from "../../../../common/containers/TableView"
import moment from "moment"
import Swal from 'sweetalert2'
import Helper from '../../../../Helper'

let CheckDetail = ({ setPageAttr, methods: { callCheckItemListGet }, list }) => {
    const params = useParams()
    const [checkId] = useState(!params.checkId ? '' : params.checkId)
    let [searchParams] = useSearchParams();

    const showReason = (item) => {
        Swal.fire({
            html: `<div style="font-weight:bold;text-align:left;">Motivos do status:</div><div style="width:200px;text-align:left;margin-top:15px;">${Helper.nl2br(item.reason)}</div>`
        })
    }

    const headers = [
        {
            type: 'info',
            name: 'id',
            align: 'right',
            label: 'ID'
        },
        {
            type: 'info',
            name: 'company',
            align: 'left',
            label: 'Empresa'
        },
        {
            type: 'info',
            name: 'region',
            align: 'left',
            label: 'Região'
        },
        {
            type: 'info',
            name: 'code',
            align: 'right',
            label: 'Código'
        },
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'info',
            name: 'category',
            align: 'left',
            label: 'Categoria'
        },
        {
            type: 'info',
            name: 'user',
            align: 'left',
            label: 'Usuário'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Status',
            custom: (a) => {
                switch (a.status) {
                    case 'active':
                        return <span className='btn btn-sm btn-success'>ATIVO</span>
                    case 'inactive':
                        return (
                            <>
                                <span className='btn btn-sm btn-danger mr-1'>INATIVO</span>
                                <button type='button' title='Motivos' className='btn btn-sm btn-warning rounded rounded-circle' onClick={_ => showReason(a)}><i className='fas fa-info'></i></button>
                            </>
                        )
                    default:
                        return <>Error</>

                }
            }
        },
        {
            type: 'datetime',
            name: 'dateCheck',
            align: 'right',
            label: 'Verificado Em'
        },
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callCheckItemListGet(checkId, {}, pg)
    }, [callCheckItemListGet, searchParams, checkId])

    useEffect(() => {
        setPageAttr({
            title: 'Detalhe do Turno',
            caption: 'Detalhe da checagem do turno realizado as ' + (list.checkDate ? moment(list.checkDate).format("DD/MM/YYYY HH:mm") : ''),
            btns: [],
            tabs: [
                {
                    active: false,
                    to: '/checks',
                    label: 'Informações'
                },
                {
                    active: true,
                    to: '/checks/detail/' + checkId,
                    label: 'Detalhes do Turno'
                }
            ]
        })
    }, [setPageAttr, checkId, list])


    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/checks/detail/' + checkId} />
    )
}

const mapStateToProps = ({ check: { checkItems: { list } } }) => ({
    list
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callCheckItemListGet,
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckDetail)